"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = theme => ({
  menuItem: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: theme.menu.item.bgColor,
    transition: theme.transition(['background']),
    position: 'relative',
    '&:hover': {
      backgroundColor: theme.menu.item.hover.bgColor,
      cursor: 'pointer'
    },
    '&.active': {
      backgroundColor: theme.menu.item.active.bgColor,
      '& $icon': {
        '& .fill': {
          fill: theme.menu.item.active.icon
        },
        '& .stroke': {
          stroke: theme.menu.item.active.icon
        }
      },
      '&:hover': {
        cursor: 'default'
      }
    },
    '&.disabled': {
      opacity: theme.disabledOpacity,
      '&.active, &:hover': {
        cursor: 'default',
        backgroundColor: theme.menu.item.bgColor
      }
    },
    '&.hidden': {
      display: 'none'
    }
  },
  avatar: {},
  labelContainer: {
    flexGrow: 1,
    overflow: 'hidden'
  },
  labelContainerContent: {
    overflow: 'hidden',
    display: 'inline-block',
    verticalAlign: 'top',
    wordBreak: 'break-all',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    width: '100%',
    marginTop: -1
  },
  label: {
    '&$labelContainerContent': {
      fontSize: theme.menu.item.label.fontSize,
      color: theme.menu.item.label.color
    }
  },
  children: {
    '&$labelContainerContent': {
      fontSize: theme.menu.item.children.fontSize,
      color: theme.menu.item.children.color,
      marginTop: 2
    }
  },
  icon: {},
  iconLeft: {},
  iconRight: {},
  badge: {
    borderColor: 'transparent',
    border: 0
  },
  small: {
    minHeight: 32,
    paddingLeft: 12,
    paddingRight: 12,
    '& $avatar, & $iconLeft': {
      marginRight: 8
    },
    '& $iconRight, & $badge': {
      marginLeft: 12
    }
  },
  medium: {
    minHeight: 36,
    paddingLeft: 16,
    paddingRight: 16,
    '& $avatar, & $iconLeft': {
      marginRight: 12
    },
    '& $iconRight, & $badge': {
      marginLeft: 16
    }
  },
  large: {
    minHeight: 56,
    paddingLeft: 16,
    paddingRight: 16,
    '& $avatar, & $iconLeft': {
      marginRight: 12
    },
    '& $iconRight, & $badge': {
      marginLeft: 16
    }
  }
});

exports.default = _default;